/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';
import React from 'react';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';

const CancellationPopup = ({
  modalTitle = 'Cancel',
  open,
  label = "Are you sure you don't want to save the record?",
  handleClose = () => {},
  onConfirmClick = () => {},
}) => {
  return (
    <Dialog
      open={open}
      className='multiGroupDialog custom-dialog-box dialog-420'
      onClose={(reason) => {
        if (reason === 'backdropClick' && reason === 'escapeKeyDown') {
          handleClose();
        }
      }}
    >
      <DialogContent>
        <div className='custom-panel'>
          <div className='panel-header'>
            <span className='float-left'> {modalTitle} </span>
            <span className='float-right' role='button' onClick={handleClose}>
              <i className='fa fa-times-circle' aria-hidden='true' />
            </span>

            <div className='clearfix' />
          </div>
          <div className='text-center modal-alignment'>
            <DialogContentText style={{ color: 'black' }}>
              {label}
            </DialogContentText>
          </div>
        </div>
      </DialogContent>

      <DialogActions>
        <div className='btn-wrapper my-2'>
          <Button
            onClick={onConfirmClick}
            color='primary'
            className='btn btn-success btn-search mr-2'
            autoFocus
          >
            <SVGComponent iconName='Icon_awesome-check-circle' />
            Yes
          </Button>
          <Button
            onClick={handleClose}
            color='primary'
            className='btn btn-cancel btn-primary'
          >
            <SVGComponent iconName='Icon-cancel' />
            No
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default CancellationPopup;
